import { combineReducers } from 'redux';
import room from './room';
import me from './me';
import producers from './producers';
import consumers from './consumers';
import transports from './transports';
import peers from './peers';
import lobbyPeers from './lobbyPeers';
import peerVolumes from './peerVolumes';
import notifications from './notifications';
import toolarea from './toolarea';
import chat from './chat';
import files from './files';
import recorder from './recorder';
import settings from './settings';
import mediaSession from './mediaSession';
import config from './config';
import intl from './intl';
import appearance from './appearance';
import webinar from './webinar';
import transcriptionreducer from './transcriptionreducer';
import viewTranscription from './transcriptionView';
import privateChat from './privateChat';
import tpscreensdata from './tpScreen';
import presence from './presence';

export default combineReducers({
	// intl : intlReducer,
	room,
	me,
	producers,
	consumers,
	transports,
	peers,
	lobbyPeers,
	peerVolumes,
	notifications,
	toolarea,
	chat,
	privateChat,
	files,
	recorder,
	settings,
	mediaSession,
	config,
	intl,
	appearance,
	webinar,
	transcriptionreducer,
	viewTranscription,
	tpscreensdata,
	presence
});
